import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import "./App.css";
import logo from "./Media/logo.svg";
import body from "./Media/body.svg";
import x from "./Media/X.svg";
import yt from "./Media/YT.svg";
import tt from "./Media/Tt.svg";
import sc from "./Media/Sc.svg";
import insta from "./Media/Ins.svg";
import fb from "./Media/Fb.svg";
import sound from "./Media/SC soundcloud.svg";
import follow from "./Media/follow.svg";

function App() {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wruxit8",
        "template_npmgvel",
        form.current,
        "ruZABujQuvWWA0pjp",
      )
      .then(
        (result) => {
          setModalOpen(false);
          setIsConfirmationModalOpen(true);
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          alert("Something went wrong. Please try again later.");
        },
      );
  };

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleBackgroundClick = (e) => {
    if (e.target.className === "modal") {
      closeModal();
    }
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };

  return (
    <div className="App">
      <div className="home-nav">
        <a href="/">
          <img src={logo} alt="logo" />
        </a>
      </div>
      <div className="home-body">
        <img src={body} alt="body" />
      </div>
      <div className="home-foot">
        <img className="follow" src={follow} alt="follow" />
        <div className="socials">
          <a
            href="https://instagram.com/asiamagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img src={insta} alt="socials" />
          </a>
          <a
            href="https://youtube.com/@iamasiama"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img src={yt} alt="socials" />
          </a>
          <a
            href="https://twitter.com/iamasiama"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img src={x} alt="socials" />
          </a>
          <a
            href="https://snapchat.com/add/iamasiama"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img src={sc} alt="socials" />
          </a>
          <a
            href="https://facebook.com/iamasiama"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img src={fb} alt="socials" />
          </a>
          <a
            href="https://tiktok.com/@iamasiama"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img src={tt} alt="socials" />
          </a>
          <a
            href="https://soundcloud.com/iamasiama"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img src={sound} alt="socials" />
          </a>
        </div>
        <div className="contact-btn">
          <button onClick={openModal}>CONTACT US</button>
          <p className="copyright">&copy; 2024 ASIAMA</p>
        </div>
        {isModalOpen && (
          <div className="modal" onClick={handleBackgroundClick}>
            <div className="modal-content">
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
              <h2>CONTACT US</h2>
              <form ref={form} onSubmit={sendEmail}>
                <input
                  type="text"
                  name="user_name"
                  placeholder="Full Name"
                  required
                />
                <input
                  type="email"
                  name="user_email"
                  placeholder="Email Address"
                  required
                />
                <input
                  type="tel"
                  name="user_number"
                  placeholder="Phone Number"
                  required
                />
                <input type="text" name="subject" placeholder="Subject" />
                <textarea
                  rows={7}
                  name="message"
                  placeholder="Message"
                  required
                ></textarea>
                <button type="submit">Send Message</button>
              </form>
            </div>
          </div>
        )}
        {isConfirmationModalOpen && (
          <div className="modal">
            <div className="modal-submitted">
              <p>Thank you for your message.</p>
              <p>We'll be in touch with you soon.</p>
              <button className="confirm-btn" onClick={closeConfirmationModal}>
                Return
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
